var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAlertMegaphone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 45",
    id: "Layer_45"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17,24.38a2,2,0,0,1-.89-.21L11.76,22H4a2,2,0,0,1-2-2V7A2,2,0,0,1,4,5h7.76l4.35-2.17A2,2,0,0,1,19,4.62V22.38a2,2,0,0,1-2,2ZM4,7V20h8a1,1,0,0,1,.45.11L17,22.38V4.62L12.45,6.89A1,1,0,0,1,12,7Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9,30H5a1,1,0,0,1-1-.87l-1-8a1,1,0,0,1,.24-.79A1,1,0,0,1,4,20H7.7a1,1,0,0,1,1,.84l1.3,8a1,1,0,0,1-.23.81A1,1,0,0,1,9,30ZM5.88,28H7.82l-1-6H5.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,19a1,1,0,0,1-1-1V9a1,1,0,0,1,2,0v9A1,1,0,0,1,12,19Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21,10a1,1,0,0,1-.89-.55,1,1,0,0,1,.44-1.34l8-4a1,1,0,1,1,.9,1.78l-8,4A.93.93,0,0,1,21,10Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29,15H21a1,1,0,0,1,0-2h8a1,1,0,0,1,0,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29,24a1,1,0,0,1-.35-.06l-8-3a1,1,0,1,1,.7-1.88l8,3A1,1,0,0,1,29,24Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.38,20.77A1,1,0,0,0,4,21h8l4.55,2.28a1,1,0,0,0,1.45-.9v-.83l-1-5.32c0,2.31-1,2.24-5.63,2.24S4,15.91,4,14Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "4.37 24.38 7.82 22 6.1 20.7 4 21.5 4.37 24.38"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertMegaphone);
export default __webpack_public_path__ + "static/media/alert_megaphone.54742715940a341056a0b7d585ac5136.svg";
export { ForwardRef as ReactComponent };